export default {
    name: "Breadcrumb",
    props: {
        items: {
            type: Array,
            required: true
        }
    }
};
